export default __webpack_public_path__ + "static/media/Asset 3@10x-8.f9f21799.png";